import config from "../../../settings/config";

export async function getProfile(token) {
    try {
        const response = await fetch(`${config.app.host}/api/v1/user/getprofile`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${token}`,
            }
        });

        if (!response.ok) {
            const errorMessage = `Ошибка ${response.status}: ${await response.text()}`;
            console.error(errorMessage);
            return null;
        }

        return await response.json();

    } catch (err) {
        console.error("Ошибка при запросе устройств:", err);
        return null;
    }
}
